export interface Notification {
  type: string
  message: string
}

export function useNotification() {
  const notification = useState<Notification | undefined>('notification', () => undefined)

  const show = (not: Notification) => {
    notification.value = { ...not, message: not.message.replace('ApolloError: ', '') }
    setTimeout(() => {
      close()
    }, 5000)
  }

  const close = () => {
    notification.value = undefined
  }

  return {
    notification,
    show,
    close,
  }
}
